import ProspectsController from './prospects.controller';

export default {
    template: require('./prospects.tpl.html'),
    controller: ProspectsController
};
